import type {FC} from "react";

interface MobileHeaderProps { onMenuClick: () => void; title: string; }
const MobileHeader: FC<MobileHeaderProps> = ({ onMenuClick, title }) => (
    <header
        className="lg:hidden bg-slate-900/70 backdrop-blur-md p-4 flex items-center justify-between sticky top-0 z-20 border-b border-slate-800">
        <button onClick={onMenuClick} className="text-slate-300 hover:text-white">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                 stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <line x1="3" y1="12" x2="21" y2="12"/>
                <line x1="3" y1="6" x2="21" y2="6"/>
                <line x1="3" y1="18" x2="21" y2="18"/>
            </svg>
        </button>
        <img
            src="/logo3.webp"
            alt="Logo"
            className="h-8"
        />
        <div className="w-6"></div>
    </header>
);

export default MobileHeader;